import { Pipe, PipeTransform } from '@angular/core';

import { sanitizeAllowlistHtml } from '../utils/allowlist-html-sanitizer';

const ALLOWED_HTML_TAGS = ['b', 'blockquote', 'br', 'em', 'i', 'li', 'ol', 'p', 's', 'strong', 'u', 'ul'];

@Pipe({
  name: 'consultantFormattedText',
  standalone: false,
})
export class ConsultantFormattedTextPipe implements PipeTransform {
  public transform(value: string | null | undefined): any {
    return sanitizeAllowlistHtml(value, {
      allowedTags: ALLOWED_HTML_TAGS,
      preserveLineBreaks: true,
    });
  }
}
